import BaseApi from '../base/base'
import Chapter from '../../models/chapter'

export default class ChapterApi extends BaseApi {
  constructor() {
    super()
    this.path = ''
  }

  async index(params = { courseId: '0', myCourse: false }) {
    this.path = `/courses/${params.courseId}/chapters`

    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new Chapter(element)
    })
  }
}
